import { Checkbox, FormControlLabel, Grid, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { Card } from 'components'
//import { SpecificCategoryCourses } from 'components'
import { CourseCard } from 'components'
import { CategoryTitle } from 'components'
import React , {useState , useEffect } from 'react'
import useHttp from "../../../../hooks/use-http";
import { ShieldKeyIcon } from 'Sui_Icons'
import { convertToPersianNumber } from 'utils'
import { Filters } from '../Filters/Filters'
import { useParams } from 'react-router-dom';

export const CoursesCollection = () => {
    const { categoryId } = useParams();
    const { isLoading, sendRequest: fetchCourseCategories } = useHttp();
    const [courseCategories ,setCourseCategories ] = useState([]);
    const [categoryTitle , setCategoryTitle] = useState();

    useEffect(() => {
        const fetchCourseCategoriesHandler = (course) => {
            console.log("CoursesCollection");
            console.log(course.data.educations[0].category.name);
            setCategoryTitle(course.data.educations[0].category.name)
            setCourseCategories(course.data.educations)
        };
        fetchCourseCategories({ url: `/home/courses/${categoryId}` }, fetchCourseCategoriesHandler);
    }, [fetchCourseCategories]);

    return (
            <>
            {console.log(courseCategories)}
            <Box sx={{ my: 2, width:'100%' }}>
                <CategoryTitle
                Icon={ShieldKeyIcon}
                title={categoryTitle} 
                />
                <Grid container spacing={2} display='flex'sx={{mt:0.5}} >
                    {courseCategories.map(course =>
                        <Grid item xs={12} md={3}>
                            <CourseCard 
                                key={course.id} 
                                img = {course.titleImage}
                                title = {course.title}
                                caption = {course.description} 
                                teacherName = {course.creator.fullName} 
                                teacherPhoto = {course.titleImage}
                                length = {parseInt(course.time)} 
                                price = {course.entranceFee} 
                                id = {course.id } 
                            />
                        </Grid>)}
                </Grid>
            </Box>
            </>               
        )
}
